import type { AuthenticatedUser } from '@omnipresentgroup/auth';
import { AUTH0_ROLES, AUTH0_USERID } from '@omnipresentgroup/constants';
import { useLDClient } from '@omnipresentgroup/launchdarkly';
import { useEffect } from 'react';

export const useLaunchDarkly = (user?: AuthenticatedUser) => {
  const ldClient = useLDClient();

  const userId = user?.[AUTH0_USERID];
  const userEmail = user?.email;

  const companyId = user?.[AUTH0_ROLES].find(
    (role) => role.type === 'manager',
  )?.tenantId;

  useEffect(() => {
    if (userId && userEmail && companyId && ldClient?.identify) {
      ldClient.identify({
        kind: 'multi',
        user: {
          key: userId,
          anonymous: true,
          email: userEmail,
        },
        organization: {
          key: companyId,
          anonymous: true,
        },
      });
    }
  }, [ldClient, userId, userEmail, companyId]);
};
